function addEvent(evnt, elem, func) {
    if (elem.addEventListener) { // W3C DOM
      elem.addEventListener(evnt, func, false);
    }
    else if (elem.attachEvent) { // IE DOM
      elem.attachEvent('on' + evnt, func);
    }
    else { // No much to do
      elem['on' + evnt] = func;
    }
  }

  // classes.js

  /**
   * Returns whether the given element has the given class.
   *
   * @param {Element} element
   * @param {string} className
   * @returns {boolean}
   */
  function hasClass(element, className) {
  	className = " " + className + " ";
  	return (" " + element.className + " ").replace(/[\n\t]/g, " ").indexOf(className) > -1
  }

  function addClass(elements, className) {
    if ( elements.length === undefined ) elements = [elements];
    for (var i = 0; i < elements.length; i++) {
      var element = elements[i];
      if (!hasClass(element, className)) {
        if (element.classList) {
          element.classList.add(className);
        } else {
          element.className = ( element.className + ' ' + className ).replace( /\s+/g, ' ');
        }
      }
    }
  }

  function removeClass(elements, className) {
    if ( elements.length === undefined ) elements = [ elements ];
    for (var i = 0; i < elements.length; i++) {
      var element = elements[i];
      if (hasClass(element, className)) {
        if (element.classList) {
          element.classList.remove(className);
        } else {
          element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
      }
    }
  }

  var entityMap = [
    [ "&", "&amp;" ],   [ "<", "&lt;" ],   [ ">", "&gt;" ],
    [ '"', '&quot;' ],  [ "'", '&#39;' ],  [ "/", '&#x2F;' ],
    [ "@", "&#64;" ],   [ "\\", '&#92;' ],
    [ "[", '&#91;' ],   [ "]", '&#93;' ],
    [ "{", '&#123;' ],  [ "}", '&#125;' ]
  ];
  function escapeRegex(s) {
    for (var i = 0; i < entityMap.length; i++) {
      for (var j = 0; j < entityMap[i].length; j++) {
        if (s == entityMap[i][j]) return entityMap[i][Math.abs(j-1)];
      }
    }
    return s;
  }
  function escapeHtml(type, string) {
    if(!string) return "";
    if(type == 1) return String(string).replace(/(&(?:amp|lt|gt|quot|#39|#x2F|#64|#92|#91|#93|#123|#125);)/g, function (s) { return escapeRegex(s); });
    else return String(string).replace(/[&<>"'\/@\\[\]{}]/g, function (s) { return escapeRegex(s); });
  }

  var elemInput           = document.getElementById("escaped-text-input"),
      elemOutputEscaped   = document.getElementById("output-text-escaped"),
      elemOutputDisplayed = document.getElementById("output-text-displayed");

  var outputFaded = 1;

  function unToggleNone(elem, thisClass) { if(hasClass(elem, thisClass)) removeClass(elem, thisClass); }
  function execEscapes(type) {
    var escapedInput = escapeHtml(type, elemInput.value);

    elemOutputEscaped.textContent = escapedInput;
    elemOutputDisplayed.innerHTML  = escapedInput;

    if ( outputFaded )
    {
      unToggleNone(elemOutputEscaped,  'text-none-escaped');
      unToggleNone(elemOutputDisplayed, 'text-none-displayed');

      outputFaded = 0;
    }

    Prism.highlightElement(elemOutputEscaped);
    // if ( type == 0 ) Prism.highlightElement(elemOutputDisplayed);
    Prism.highlightElement(elemOutputDisplayed);
  }

   addEvent('click', document.getElementById('escaped-text-escape'),   function() { execEscapes(0); });
   addEvent('click', document.getElementById('escaped-text-unescape'), function() { execEscapes(1); });
   // addEvent('click', document.getElementById('escaped-text-reset'), function() { execEscapes(2); });
